'use client';

import Link from 'next/link';

import { LEGAL_ROUTES } from '@/common/constants';

export function Footer() {
  return (
    <>
      <hr aria-hidden="true" className="w-full" />
      <footer className="w-full bg-muted/50">
        <div className="mx-auto flex h-auto max-w-6xl flex-col items-center justify-between p-4 md:h-16 md:flex-row">
          <nav
            aria-label="Legal"
            className="mb-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 md:mb-0 md:justify-start"
          >
            <Link
              href={LEGAL_ROUTES.termsOfUse}
              className="text-sm whitespace-nowrap text-muted-foreground hover:underline"
            >
              Terms of Use
            </Link>
            <Link
              href={LEGAL_ROUTES.privacyNotice}
              className="text-sm whitespace-nowrap text-muted-foreground hover:underline"
            >
              Privacy Notice
            </Link>
            <Link
              href={LEGAL_ROUTES.cookieNotice}
              className="text-sm whitespace-nowrap text-muted-foreground hover:underline"
            >
              Cookie Notice
            </Link>
            <Link
              href={LEGAL_ROUTES.doNotSell}
              className="text-sm whitespace-nowrap text-muted-foreground hover:underline"
            >
              Do Not Sell or Share My Info
            </Link>
          </nav>
          <p className="text-center text-sm text-muted-foreground md:text-right">
            © <span suppressHydrationWarning>{new Date().getFullYear()}</span> Bazak. All rights
            reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
